module.exports = __webpack_public_path__ + "static/gtm-e509b84bd2f616d6843852f9c76b3728.png";